import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-automation",
  "use": "icon-automation-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-automation\">\n<path d=\"M5.48837 2H18.5116C20.4302 2 22 3.56977 22 5.48837V18.5116C22 20.4302 20.4302 22 18.5116 22H5.48837C3.56977 22 2 20.4302 2 18.5116V5.48837C2 3.56977 3.56977 2 5.48837 2ZM5.48837 4.09302C4.72093 4.09302 4.09302 4.72093 4.09302 5.48837V18.5116C4.09302 19.2791 4.72093 19.907 5.48837 19.907H18.5116C19.2791 19.907 19.907 19.2791 19.907 18.5116V5.48837C19.907 4.72093 19.2791 4.09302 18.5116 4.09302H5.48837Z\" fill=\"currentColor\" />\n<path d=\"M13.3953 6.06977L7.81395 13.5116H11.3023L10.7209 18.6279L16.4186 10.8372H12.814L13.3953 6.06977Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/automation.svg
// module id = WtGV
// module chunks = 262